import script from "./orders.vue?vue&type=script&lang=ts&setup=true"
export * from "./orders.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__